import { StorageKeys } from "@utils/enums";

import { PreferredStoreService } from "@services/preferredStore.service";

export function getPreferredCheckoutStore(
    shoppingCartStoreId?: string,
    customerStoreId?: string | null,
): string | undefined {
    return (
        shoppingCartStoreId ||
        customerStoreId ||
        PreferredStoreService.getPreferredStoreOfTheUser() ||
        undefined
    );
}

export function getPreferredStoreCodeForStock(): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }
    
    const sessionStoreData = window.sessionStorage.getItem(
        StorageKeys.PreferredStore,
    );

    let sessionStoreCode;
    if (sessionStoreData) {
        try {
            sessionStoreCode = JSON.parse(sessionStoreData)?.shopId;
        } catch {
            sessionStoreCode = undefined;
        }
    }

    return (
        PreferredStoreService.getLastKnownCartStoreId() ||
        sessionStoreCode ||
        PreferredStoreService.getPreferredStoreOfTheUser() ||
        undefined
    );
}
